import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-576c614c")

_pushScopeId("data-v-576c614c")
const _hoisted_1 = { class: "table-generator" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "lef" }
const _hoisted_4 = {
  key: 1,
  class: "custom"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "label",
  style: {"flex":"1"}
}, "行数：", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "label",
  style: {"flex":"1"}
}, "列数：", -1)
const _hoisted_9 = { class: "btns" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, "表格 " + _toDisplayString(_ctx.endCell.length ? `${_ctx.endCell[0]} x ${_ctx.endCell[1]}` : ''), 1),
      _createVNode("div", {
        class: "right",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCustom = !_ctx.isCustom))
      }, _toDisplayString(_ctx.isCustom ? '返回' : '自定义'), 1)
    ]),
    (!_ctx.isCustom)
      ? (_openBlock(), _createBlock("table", {
          key: 0,
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.endCell = [])),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClickTable()))
        }, [
          _createVNode("tbody", null, [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (row) => {
              return _createVNode("tr", { key: row }, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (col) => {
                  return _createVNode("td", {
                    onMouseenter: ($event: any) => (_ctx.endCell = [row, col]),
                    key: col
                  }, [
                    _createVNode("div", {
                      class: ["cell", { 'active': _ctx.endCell.length && row <= _ctx.endCell[0] && col <= _ctx.endCell[1] }]
                    }, null, 2)
                  ], 40, ["onMouseenter"])
                }), 64))
              ])
            }), 64))
          ])
        ], 32))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputNumber, {
              min: 1,
              max: 20,
              value: _ctx.customRow,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.customRow = $event)),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputNumber, {
              min: 1,
              max: 20,
              value: _ctx.customCol,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.customCol = $event)),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Button, {
              class: "btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
            }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "btn",
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.insertCustomTable()))
            }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]))
  ]))
})